import type { FC, ReactNode } from 'react'

import { useId } from 'react'
import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    accent?: string
}

// Two interlocking loops. Each ring is masked where the other one passes over it,
// so the over-under effect works on any background.
export const LogoMark: FC<LogoMarkProps> = ({ className, accent = 'var(--color-violet)' }): ReactNode => {
    const id = useId()
    const maskLeft = `${id}-left`
    const maskRight = `${id}-right`

    return (
        <svg
            viewBox='0 0 28 20'
            fill='none'
            aria-hidden='true'
            className={cn('h-5 w-7 shrink-0', className)}
        >
            <defs>
                <mask id={maskLeft} maskUnits='userSpaceOnUse' x='0' y='0' width='28' height='20'>
                    <rect width='28' height='20' fill='white' />
                    <path d='M17.19 16.76A7 7 0 0 1 12.24 11.81' stroke='black' strokeWidth='6.2' strokeLinecap='round' />
                </mask>

                <mask id={maskRight} maskUnits='userSpaceOnUse' x='0' y='0' width='28' height='20'>
                    <rect width='28' height='20' fill='white' />
                    <path d='M10.81 3.24A7 7 0 0 1 15.76 8.19' stroke='black' strokeWidth='6.2' strokeLinecap='round' />
                </mask>
            </defs>

            <circle cx='9' cy='10' r='7' stroke='currentColor' strokeWidth='3' mask={`url(#${maskLeft})`} />
            <circle cx='19' cy='10' r='7' stroke={accent} strokeWidth='3' mask={`url(#${maskRight})`} />
        </svg>
    )
}

interface LogoProps {
    className?: string
    markClassName?: string
    accent?: string
}

export const Logo: FC<LogoProps> = ({ className, markClassName, accent }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2 text-ink', className)}>
            <LogoMark className={markClassName} accent={accent} />

            <span className='text-[19px] font-bold leading-none tracking-[-0.04em]'>
                FlowCraft
            </span>
        </span>
    )
}
